const ACTION_COLUMN_FIELDS = new Set(["actions", "action"]);

const resolveColumnWidth = (col) => col.width ?? col.minWidth ?? 120;

export const normalizeColumnsForPinnedLayout = (
  columns,
  pinnedFields,
  { compact = false } = {},
) => {
  if (!pinnedFields?.length || !columns?.length) return columns;

  const pinnedSet = new Set(pinnedFields);
  return columns.map((col) => {
    const baseWidth = resolveColumnWidth(col);
    if (pinnedSet.has(col.field)) {
      const width = compact ? Math.min(baseWidth, 132) : baseWidth;
      return { ...col, flex: 0, width, minWidth: width };
    }
    return {
      ...col,
      flex: col.flex ?? 0,
      minWidth: col.minWidth ?? baseWidth,
      width: col.width ?? col.minWidth ?? baseWidth,
    };
  });
};

export const getPinnedRightFields = (columns, pinActionsColumn = true) => {
  if (!columns?.length) return [];

  const fields = new Set();
  columns.forEach((col) => {
    if (!col?.field) return;
    if (col.pinned === "right") {
      fields.add(col.field);
    } else if (pinActionsColumn && ACTION_COLUMN_FIELDS.has(col.field)) {
      fields.add(col.field);
    }
  });

  return [...fields];
};

export const buildPinnedRightColumnSx = (pinnedFields) => {
  if (!pinnedFields?.length) return {};

  return pinnedFields.reduce((sx, field) => {
    const cellSelector = `& .MuiDataGrid-cell[data-field="${field}"]`;
    const headerSelector = `& .MuiDataGrid-columnHeader[data-field="${field}"]`;
    const hoverSelector = `& .MuiDataGrid-row:hover .MuiDataGrid-cell[data-field="${field}"]`;

    sx[cellSelector] = {
      position: "sticky",
      right: 0,
      zIndex: 2,
      flexShrink: 0,
      backgroundColor: "#fff",
      boxShadow: "-4px 0 8px -4px rgba(0, 0, 0, 0.12)",
    };
    sx[headerSelector] = {
      position: "sticky",
      right: 0,
      zIndex: 1001,
      backgroundColor: "#e5f3fa",
      boxShadow: "-4px 0 8px -4px rgba(0, 0, 0, 0.12)",
    };
    sx[hoverSelector] = {
      backgroundColor: "#f9fdff",
    };

    return sx;
  }, {});
};
